import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ServerFilterParams } from "../../common.model";
import { ServereService } from "../../../server/server.service";

@Component({
  selector: "app-serverfilter",
  templateUrl: "./serverfilter.component.html"
})
export class ServerFilterComponent implements OnInit {

  @Input()
  loadingData = false;

  @Input()
  filterParams: ServerFilterParams;

  filtersCollapsed: boolean;

  @Output()
  onFilterChange = new EventEmitter<ServerFilterParams>();

 

  constructor(private serverService: ServereService) { }

  ngOnInit(): void {
    
      if (this.filterParams.hasSystem === undefined) {
        this.filterParams.hasSystem = null;
      }

      this.emitChanges();
    
  }
  

  setHasSystem(value: boolean | null): void {
    this.filterParams.hasSystem = value;
    this.emitChanges();
  }

  emitChanges(): void {
    this.filterParams.pageNumber = 1;
    this.onFilterChange.emit({
      ...this.filterParams,
    });
  }


  filterChanged(event: any): void {
    this.filterParams.pageNumber = 1;
    this.onFilterChange.emit(this.filterParams);

  }
}
